import { addSubGroup } from 'api/management'
import { NewSubGroupPayload } from 'api/management'
import { useAlert } from 'hooks/useDialog'
import { useForm, FormProvider } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import GroupFormFields from './GroupFormFields'

const NEW_GROUP_TMPL: NewSubGroupPayload = {
  name: '',
  operationFlowType: 'normal',
  users: [],
}

export default function GroupEdit() {
  const navigate = useNavigate()
  const alert = useAlert()
  const form = useForm({ defaultValues: NEW_GROUP_TMPL })

  const handleAdd = async (data: NewSubGroupPayload) => {
    try {
      await addSubGroup(data)
      alert({ message: ['登録完了', 'グループが追加されました'] })
      navigate('..')
    } catch {
      alert({ message: ['登録失敗', 'グループ登録に失敗しました'] })
    }
  }

  return (
    <FormProvider {...form}>
      <GroupFormFields title={'新規追加'} mode={'new'} onAdd={handleAdd} />
    </FormProvider>
  )
}
